(function () {
  'use strict';

  /** Checkout button */
  class CheckoutButton extends HTMLElement {
    constructor() {
      super();

      this.lock = false;
      this.variantId = this.getAttribute('variant');
    }
    connectedCallback() {
      this.addEventListener('click', this._buyNow.bind(this));
    }
    async _buyNow(e) {
      e.preventDefault();

      if (!this.variantId) {
        return;
      }

      if (this.lock == true) {
        return;
      }

      try {
        this.lock = true;

        this.classList.add('loading');

        await fetch('/cart/add.js', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: this.variantId,
            quantity: 1,
          }),
        })
          .then((r) => {
            document.documentElement.classList.toggle('invisible');
            return r.json();
          })
          .then(() => {
            setTimeout(() => {
              window.location.href = window.location.origin + '/checkout';
            }, 300);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('checkout-button')) {
    window.customElements.define('checkout-button', CheckoutButton);
  }

  /** Back to the top */
  class BackToTop extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.addEventListener('DOMContentLoaded', this.show.bind(this));
      window.addEventListener('scroll', this.show.bind(this));
      this.addEventListener('click', this.click.bind(this));
    }
    show() {
      try {
        const documentHeight = document.documentElement.scrollHeight;
        const footerHeight = document.querySelector('.new-footer').offsetHeight;
        const footerTop = documentHeight - footerHeight - window.screen.availHeight;

        if (window.scrollY >= footerTop) {
          this.classList.add('show');
        } else {
          this.classList.remove('show');
        }
      } catch (err) {
        console.error(err);
      }
    }
    click() {
      window.scroll(0, 0);
    }
  }
  if (!window.customElements.get('back-to-top')) {
    window.customElements.define('back-to-top', BackToTop);
  }

  /** Line item buttom */
  class LineItemButton extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onClickListener = this._onClickListener.bind(this);
    }
    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.onClickListener);
      }
    }
    _onClickListener(e) {
      let quantity;

      e.preventDefault();

      const lineItem = this.closest('line-item-quantity');
      const quantityInput = lineItem.querySelector('.quantity-input');
      const action = this.dataset.action;

      // lineItem.querySelectorAll('button,input').forEach((el) => (el.disabled = true));

      switch (action) {
        case 'minus':
          if (quantityInput.value == 1) {
            return;
          }

          quantity = parseInt(quantityInput.value);
          quantity--;
          quantity = Math.max(1, quantity);
          quantityInput.value = quantity;

          quantityInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
          break;

        case 'plus':
          quantity = parseInt(quantityInput.value);
          quantity++;
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
          break;
      }
    }
  }

  if (!window.customElements.get('line-item-button')) {
    window.customElements.define('line-item-button', LineItemButton);
  }

  class DiscountField extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input');
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
    }
    connectedCallback() {
      this.form.addEventListener('submit', this.submit.bind(this));
    }
    submit(e) {
      e.preventDefault();
      try {
        const discountCode = this.input.value;

        if (discountCode !== '') {
          window.location.href = `/discount/${encodeURI(discountCode)}?redirect=${window.location.pathname}`;
        } else {
          this.button.removeAttribute('aria-busy');
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('discount-field')) {
    window.customElements.define('discount-field', DiscountField);
  }

  /* X-Timer */
  class XTimer extends HTMLElement {
    constructor() {
      super();

      this.end = this.getAttribute('end');
      this.message = this.getAttribute('message');
      this.showDays = Boolean(this.getAttribute('show-days'));
      this.parent = this.getAttribute('parent');
    }
    connectedCallback() {
      this.run();
    }
    run() {
      /**
       * Timer format: yyyy-mm-ddTHH:mm:ssZ
       * Example: 2026-02-10T00:00:00Z (standard of the date & time for shopify field type)
       */
      const endTimestamp = new Date(this.end).getTime();

      const intervalTime = setInterval(() => {
        const now = new Date().getTime();
        const distance = endTimestamp - now;

        if (distance < 0) {
          if (this.parent) {
            const parent = this.closest(this.parent);

            parent ? parent.remove() : this.remove();
          } else {
            this.remove();
          }
          return clearInterval(intervalTime);
        }

        const _days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const _hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const _minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const _seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (typeof callback === 'function') {
          return callback(_days, _hours, _minutes, _seconds);
        }

        let response = '';

        if (this.showDays === true) {
          response += ('00' + _days).slice(-2) + 'd ';
        }
        response += ('00' + _hours).slice(-2) + ':';
        response += ('00' + _minutes).slice(-2) + ':';
        response += ('00' + _seconds).slice(-2);

        this.innerHTML = `${this.message || ''} ${response}`;
      }, 1000);
    }
  }
  if (!window.customElements.get('x-timer')) {
    window.customElements.define('x-timer', XTimer);
  }

  class TimerPopup extends HTMLElement {
    #discountCode;
    #applyButton;
    #delay;
    #closeButton;

    constructor() {
      super();

      this.#closeButton = this.querySelector('.popup__close-button');
      this.#discountCode = this.querySelector('.popup__discount-code');
      this.#applyButton = this.querySelector('.button--apply');
      this.#delay = this.getAttribute('delay') || 0;
    }
    connectedCallback() {
      window.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
          this._close();
        }
      });
      this.#closeButton?.addEventListener('click', this._close.bind(this));
      this.#discountCode?.addEventListener('click', this._copyDiscount.bind(this));

      window.addEventListener('timer-popup:close', this._close.bind(this));

      this._init.call(this);
    }
    disconnectedCallback() {
      this.#closeButton?.removeEventListener('click', this._close.bind(this));
      this.#discountCode?.removeEventListener('click', this._copyDiscount.bind(this));
    }
    _init() {
      const noPopup = window.sessionStorage.getItem('no-popup');

      if (noPopup && noPopup == 1) {
        this.remove();
      } else {
        if (this.#delay > 0) {
          setTimeout(() => {
            this.removeAttribute('hidden');
          }, this.#delay * 1000);
        } else {
          this.removeAttribute('hidden');
        }
      }
    }
    _close() {
      window.sessionStorage.setItem('no-popup', 1);
      this.setAttribute('hidden', true);
      setTimeout(() => this.remove(), 1000);
    }
    _copyDiscount(e) {
      e.preventDefault();

      console.log(e.currentTarget.innerText);
      navigator.clipboard.writeText(e.currentTarget.innerText);
    }
    _applyDiscount(e) {
      e.preventDefault();

      const redirect = window.location.pathname;
      const discountCode = this.#discountCode.innerText.trim();

      window.sessionStorage.setItem('no-popup', 1);
      window.location.href = window.location.origin + '/discount/' + discountCode + '?redirect=' + redirect;
    }
  }
  if (!window.customElements.get('timer-popup')) {
    window.customElements.define('timer-popup', TimerPopup);
  }

  /**
   * Back in stock
   */
  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.product = this.getAttribute('product') || null;
    }
    connectedCallback() {
      this.querySelector('form').addEventListener('submit', this._onSubmit.bind(this));
    }
    disconnectedCallback() {
      this.querySelector('form').removeEventListener('submit', this._onSubmit.bind(this));
    }
    _onSubmit(e) {
      e.preventDefault();

      try {
        if (this.product.length === 0) {
          throw new Error('O produto não está definido.');
        }

        const form = this.querySelector('form');
        const email = form.querySelector('[name="email"]');
        const listID = form.querySelector('[name="listID"]').value;
        const button = form.querySelector('.back-in-stock__button--submit');

        button.innerHTML = 'Enviando...';
        button.disabled = true;
        email.disabled = true;

        this.querySelector('.back-in-stock__content').style.display = 'block';
        this.querySelector('.back-in-stock__result').style.display = 'none';

        global.insider_object = window.insider_object || {};
        global.insider_object.user = {
          email: email.value,
          language: 'pt-br',
          gdpr_optin: true,
          email_optin: true,
          list_id: [listID],
          custom: {
            back_in_stock: this.product,
          },
        };

        setTimeout(() => {
          Insider.eventManager.dispatch('init-manager:re-initialize');
        }, 100);

        setTimeout(() => {
          const form = this.querySelector('form');
          const email = form.querySelector('[name="email"]');
          const button = form.querySelector('.back-in-stock__button--submit');

          button.innerHTML = 'Enviar';
          button.disabled = false;
          email.disabled = false;

          this.querySelector('.back-in-stock__content').style.display = 'none';
          this.querySelector('.back-in-stock__result').style.display = 'block';
        }, 1750);
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('back-in-stock')) {
    window.customElements.define('back-in-stock', BackInStock);
  }

  /** Confirmation popup */
  class ConfirmationPopup extends HTMLElement {
    #discountCode;
    #applyButton;
    #delay;
    #closeButton;
    #productForm;

    constructor() {
      super();

      this.#closeButton = this.querySelector('.popup__close-button');
      this.#discountCode = this.querySelector('.popup__discount-code');
      this.#applyButton = this.querySelector('.button--apply');
      this.#delay = this.getAttribute('delay') || 0;
      this.#productForm = document.querySelectorAll('.product-info form[action="/cart/add"]');
    }
    connectedCallback() {
      window.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
          this._close();
        }
      });
      window.addEventListener('confirmation-popup:open', (e) => {
        const title = this.querySelector('.popup__title');
        const description = this.querySelector('.popup__description');
        const [quantityUpsell, quantityNormal] = this.querySelectorAll('.popup__quantity');
        const [buttonPrimary, buttonSecondary] = this.querySelectorAll('.button');

        if (title) {
          title.innerHTML =
            e.detail.items == '1' ? 'Quer economizar mais levando 2 potes?' : 'Quer economizar mais levando 3 potes?';
        }
        if (description) {
          description.innerHTML =
            e.detail.items == '1' ? 'Aproveite FRETE GRÁTIS' : 'Aproveite FRETE GRÁTIS + pote extra';
        }
        if (quantityUpsell) {
          quantityUpsell.value = e.detail.items == '1' ? 2 : 3;
        }
        if (quantityNormal) {
          quantityNormal.value = e.detail.items == '1' ? 1 : 2;
        }

        if (buttonPrimary) {
          buttonPrimary.innerHTML =
            e.detail.items == '1' ? 'SIM! QUERO FRETE GRÁTIS' : 'SIM! QUERO FRETE GRÁTIS + POTE EXTRA';
        }
        if (buttonSecondary) {
          buttonSecondary.innerHTML =
            e.detail.items == '1' ? 'NÃO, VOU CONTINUAR COM 1 POTE' : 'NÃO, VOU CONTINUAR COM 2 POTES';
        }
        this.removeAttribute('hidden');
      });
      this.#closeButton?.addEventListener('click', this._close.bind(this));
      this.#discountCode?.addEventListener('click', this._copyDiscount.bind(this));
      window.addEventListener('timer-popup:close', this._close.bind(this));

      this._init.call(this);
    }
    disconnectedCallback() {
      this.#closeButton?.removeEventListener('click', this._close.bind(this));
      this.#discountCode?.removeEventListener('click', this._copyDiscount.bind(this));
    }
    _init() {
      const noPopup = window.sessionStorage.getItem('no-popup');
    }
    _close() {
      this.setAttribute('hidden', true);
    }
    _copyDiscount(e) {
      e.preventDefault();

      console.log(e.currentTarget.innerText);
      navigator.clipboard.writeText(e.currentTarget.innerText);
    }
    _applyDiscount(e) {
      e.preventDefault();

      const redirect = window.location.pathname;
      const discountCode = this.#discountCode.innerText.trim();

      // window.sessionStorage.setItem('no-popup', 1);
      window.location.href = window.location.origin + '/discount/' + discountCode + '?redirect=' + redirect;
    }
  }
  if (!window.customElements.get('confirmation-popup')) {
    window.customElements.define('confirmation-popup', ConfirmationPopup);
  }

  /** Products group select */

  class RemoveItem extends HTMLElement {
    constructor() {
      super();

      this.line = this.getAttribute('line');
    }
    connectedCallback() {
      this.addEventListener('click', this.click.bind(this));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.click.bind(this));
    }
    click(e) {
      e.preventDefault();

      document.dispatchEvent(
        new CustomEvent('products-group:remove-item', {
          bubbles: true,
          detail: {
            line: this.line,
          },
        }),
      );
    }
  }
  if (!window.customElements.get('button-remove-item')) {
    window.customElements.define('button-remove-item', RemoveItem);
  }
  class ProductsGroupSelect extends HTMLElement {
    constructor() {
      super();

      this.loading = true;
      this.handles = this.getAttribute('handles') || null;
      this.products = null;
      this.selectedProducts = [];
      this.selectedItemsHtml = this.querySelector('#products-group-selected-items');
      this.productsCard = this.querySelectorAll('product-card .product-card__checkbox');
      this.buttonAddItem = this.querySelectorAll('.products-group-card__button');
    }
    connectedCallback() {
      this.fetchProducts();

      this.productsCard.forEach((el) => {
        el.addEventListener('change', this._change.bind(this));
      });

      document.addEventListener('products-group:remove-item', this._removeItem.bind(this));

      this.buttonAddItem.forEach((el) => {
        el.addEventListener('click', this._addItem.bind(this));
      });
    }
    productHtml(product, i, isFree = false) {
      return `
        <div class="products-group__item h-stack gap-2 align-start">
          <input type="hidden" name="items[${i}][id]" value="${product.variants[0].id}"/>
          <div class="products-group__item-image">
            <img src="${product.featured_image}" alt="${product.title || 'Imagem do produto'}" width="64" height="64" class="rounded-lg"/>
          </div>
          <div class="products-group__item-text v-stack">
            <span class="text-xs">${product.title}</span>
            ${
              isFree == false
                ? `<div class="h-stack gap-2">
              <span class="text-xs bold">R$ ${new Intl.NumberFormat('pt-BR').format(product.price / 100)}</span>
              ${product.compare_at_price > 0 && product.compare_at_price > product.price ? `<span class="text-xs text-subdued line-through">R$ ${new Intl.NumberFormat('pt-BR').format(product.compare_at_price / 100)}</span>` : ''}
            </div>`
                : `<span class="text-xs h-stack gap-2 align-center"><span class="bold">Grátis</span> ${`<span class="text-xs text-subdued line-through">R$ ${new Intl.NumberFormat('pt-BR').format(product.price / 100)}</span>`}</span>`
            }
          </div>
          <span>
            <button-remove-item class="text-xs button--remove" line="${i}"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></button-remove-item>
          </span>
        </div>
      `;
    }
    async fetchProducts() {
      if (!this.handles) {
        return;
      }

      Promise.all(
        this.handles.split(',').map(async (handle) => await fetch(`/products/${handle}.js`).then((r) => r.json())),
      ).then((p) => {
        this.products = p;

        this.loading = false;
      });
    }
    _addItem(e) {
      e.preventDefault();

      const button = e.currentTarget;
      const id = button.dataset.id;

      try {
        const product = this.products.find((p) => p.id == id);

        if (!product) {
          throw new Error('Product does not exist.');
        }

        this.selectedProducts.push(product);

        this.render(this.selectedProducts);
      } catch (err) {
        console.error(err);
      }
    }

    _removeItem(e) {
      e.preventDefault();
      e.stopPropagation();

      const index = e.detail.line;

      this.selectedProducts = this.selectedProducts.filter((_, i) => i != index);

      this.render(this.selectedProducts);
    }

    render(products) {
      const minor = products.reduce(
        (minor, item, i) => {
          if (minor.product.price > item.price) {
            minor = {
              product: item,
              index: i,
            };
          }
          return minor;
        },
        {
          product: products[0],
          index: 0,
        },
      );

      if (products.length < 1) {
        this.selectedItemsHtml.innerHTML = '<span class="text-subdued text-sm">Nenhum item selecionado</span>';
        return;
      }

      this.selectedItemsHtml.innerHTML = '';
      products.forEach((p, i) => {
        this.selectedItemsHtml.innerHTML += this.productHtml(p, i, minor.index == i && products.length > 2);
      });

      if (products.length > 2) {
        this.selectedItemsHtml.innerHTML += `
        <button type="submit" class="button product-group__button-add" is="custom-button">
          <div>Adicionar à sacola</div>
          <span class="button__loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        `;
        return;
      }
    }
  }
  if (!window.customElements.get('products-group-select')) {
    window.customElements.define('products-group-select', ProductsGroupSelect);
  }
})();
